// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ANONYMOUS_USERNAME = "anonym";
